import NodeLowTempCooler from './node-low-temp-cooler';

export default NodeLowTempCooler;
